import Vue from "vue";
import Buefy from "buefy";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import updateLocale from "dayjs/plugin/updateLocale";
import isoWeek from "dayjs/plugin/isoWeek";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/de";

import App from "./App.vue";
import store from "./store/index";
import router from "./router";

dayjs.extend(calendar);
dayjs.extend(updateLocale);
dayjs.extend(isoWeek);
dayjs.extend(relativeTime);

dayjs.locale("de");

dayjs.updateLocale("de", {
  calendar: {
    lastDay: '[Gestern um] HH:mm',
    sameDay: '[Heute um] HH:mm',
    nextDay: '[Morgen um] HH:mm',
    lastWeek: '[letzten] dddd [um] HH:mm',
    nextWeek: 'dddd [um] HH:mm',
    sameElse: 'DD.MM.YYYY [um] HH:mm'
  }
})

navigator.permissions
  .query({
    // @ts-ignore
    name: "clipboard-write"
  })
  .then(permissionStatus => {
    // Will be 'granted', 'denied' or 'prompt':
    // console.log(permissionStatus.state);

    // Listen for changes to the permission state
    permissionStatus.onchange = () => {
      // console.log(permissionStatus.state);
    };
  });

Sentry.init({
  dsn: "https://bb596fe466a848c3989bbb17d5daa946@sentry.ameo.io/2",
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
});

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultFirstDayOfWeek: 1,
  defaultDayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  defaultMonthNames: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
});

Vue.filter("truncate", (value, length) =>
  value.length > length ? `${value.substr(0, length)}…` : value
);

new Vue({
  // store,
  // router,
  render: h => h(App)
}).$mount("#app");
